function t() {
  return !1;
}
export { t as default };